import { createAction } from "@reduxjs/toolkit";

import { addPayPalActionType } from "./actionTypes";

export const addPayPal = createAction(addPayPalActionType.request);

export const addPayPalSuccess = createAction(
  addPayPalActionType.success,
  (payload) => ({ payload }),
);

export const addPayPalFailure = createAction(
  addPayPalActionType.failure,
  (error) => ({ payload: error }),
);

export const addPayPalReset = createAction(addPayPalActionType.reset);
